<template>
	<div
		:class="{ 'is-active': active, 'is-up': up }"
		class="dropdown"
		@mouseover="expand"
		@mouseout="collapse">
		<button
			ref="trigger"
			:class="triggerClass"
			:disabled="disabled"
			class="dropdown-trigger"
			@touchstart="$emit('touch')"
			@click="$emit('click')"
			@focus="expand"
			@blur="collapse">
			<slot name="trigger" />
		</button>
		<div
			v-if="active"
			ref="content"
			:style="{ left, top }"
			class="dropdown-menu"
			role="menu">
			<slot name="dropdown-content">
				<dp-box class="dropdown-content is-small" simple>
					<slot name="dropdown-items">
						<section class="dropdown-item is-relative is-paddingless is-grid has-one-column has-row-gap">
							<slot />
						</section>
					</slot>
				</dp-box>
			</slot>
		</div>
	</div>
</template>

<script>
const sharedState = {
	activeId: null,
};

export default {
	name: 'DpDropdown',
	props: {
		collapseOthers: { type: Boolean, default: true },
		disabled: { type: Boolean, default: false },
		minScreenGapPx: { type: Number, default: 16 },
		triggerClass: { type: String, default: 'button' },
	},
	data: () => ({ sharedState, active: false, left: null, top: null, up: false }),
	computed: {
		shouldCollapse() {
			return this.collapseOthers &&
				this.sharedState.activeId &&
				this.sharedState.activeId !== this._uid;
		},
	},
	watch: {
		async active(value) {
			if (!value) {
				this.left = null;
				this.top = null;
				return;
			}
			await this.$nextTick();
			Object.assign(this, calcPosition(this));
		},
		shouldCollapse(value) {
			if (value) { this.collapse(); }
		},
	},
	methods: {
		collapse() {
			this.active = false;
			if (this.sharedState.activeId === this._uid) {
				this.sharedState.activeId = null;
			}
			this.$refs.trigger.blur();
		},
		expand() {
			this.active = true;
			this.sharedState.activeId = this._uid;
		},
	},
};

function calcPosition({ $refs, minScreenGapPx }) {
	const { right } = $refs.content.getBoundingClientRect();
	const { clientWidth, clientHeight } = document.documentElement;
	const rightOverreach = right - clientWidth + minScreenGapPx;

	const contentHeight = calcHeight($refs.content);
	const { bottom } = $refs.trigger.getBoundingClientRect();
	const fitsDownwards = clientHeight - bottom - contentHeight - minScreenGapPx >= 0;
	return {
		left: rightOverreach > 0 ? `${-rightOverreach}px` : null,
		up: !fitsDownwards,
	};
}
function calcHeight(element) {
	const { top, bottom } = element.getBoundingClientRect();
	return bottom - top;
}
</script>
